import React, { useRef } from "react";
import { useGLTF, Outlines } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials} = useGLTF("/plots/11-Museum.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }

  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube250.geometry}
        material={materials["15-MuseumWhite1"]}
        position={[-0.41, 0.17, 0.402]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube517.geometry}
        material={materials["00-Base4"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube519.geometry}
        material={materials.Material}
        position={[-0.41, 0.176, 0.402]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube530.geometry}
        material={materials["15-MuseumWhite2"]}
        position={[0, 0.486, -0.312]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube532.geometry}
        material={materials["02-BenchWood"]}
        position={[-0.416, 0.648, 0.155]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube533.geometry}
        material={materials["07-WindowMat"]}
        position={[-0.416, 0.648, 0.14]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube545.geometry}
        material={materials["00-Grass1"]}
        position={[-0.476, 0.116, 0.766]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder077.geometry}
        material={materials["01-TreeGreen1"]}
        position={[-0.372, 0.359, 0.766]}
        rotation={[0, 0.141, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder078.geometry}
        material={materials["01-TreeGreen2"]}
        position={[0.401, 0.212, 0.766]}
        rotation={[0, 0.67, 0]}
        scale={1.05}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/11-Museum.glb");